import { render, staticRenderFns } from "./Solicitudes_usuarios_plataforma.vue?vue&type=template&id=e835815e&scoped=true&"
import script from "./Solicitudes_usuarios_plataforma.vue?vue&type=script&lang=js&"
export * from "./Solicitudes_usuarios_plataforma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e835815e",
  null
  
)

export default component.exports